import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import {
  Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { ChevronsUpDown, Check } from "lucide-react";

export function AssujettiCombobox({ value, onSelect, selectedLabel = "", testId = "field-assujetti" }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [label, setLabel] = useState(selectedLabel);

  useEffect(() => {
    setLabel(selectedLabel);
  }, [selectedLabel]);

  useEffect(() => {
    const t = setTimeout(async () => {
      const params = query.trim() ? { q: query.trim() } : {};
      try {
        const { data } = await api.get("/assujettis", { params });
        setResults(data.slice(0, 50));
      } catch {
        setResults([]);
      }
    }, 250);
    return () => clearTimeout(t);
  }, [query]);

  const choose = (a) => {
    setLabel(`${a.code} — ${a.redevable}`);
    onSelect(a);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-full justify-between font-normal"
          data-testid={testId}
        >
          <span className={label ? "truncate" : "truncate text-slate-400"}>
            {label || "Rechercher ou sélectionner un assujetti…"}
          </span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command shouldFilter={false}>
          <CommandInput
            placeholder="Taper un code ou un nom…"
            value={query}
            onValueChange={setQuery}
            data-testid="assujetti-combobox-input"
          />
          <CommandList>
            <CommandEmpty>Aucun assujetti trouvé</CommandEmpty>
            <CommandGroup>
              {results.map((a) => (
                <CommandItem key={a.id} value={a.id} onSelect={() => choose(a)} data-testid="assujetti-option">
                  <Check className={`mr-2 h-4 w-4 ${a.id === value ? "opacity-100" : "opacity-0"}`} />
                  <span className="mr-2 font-mono text-xs text-slate-500">{a.code}</span>
                  {a.redevable}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
